<script lang="ts">
  export let className: string = '';
</script>

<svg class="logo {className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" aria-label="SPA Studio">
  <defs>
    <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="hsl(170, 75%, 42%)" />
      <stop offset="100%" stop-color="hsl(195, 80%, 45%)" />
    </linearGradient>
  </defs>
  <!-- Abstract shield / tool shape -->
  <rect x="4" y="4" width="32" height="32" rx="10" fill="url(#logoGrad)" opacity="0.12"/>
  <path d="M20 8 L30 14 L30 26 L20 32 L10 26 L10 14 Z" fill="url(#logoGrad)" />
  <path d="M20 13 L25 16 L25 24 L20 27 L15 24 L15 16 Z" fill="white" opacity="0.25"/>
  <circle cx="20" cy="20" r="3" fill="white" opacity="0.95"/>
</svg>

<style>
  .logo {
    transition: transform 250ms ease;
  }
  .logo:hover {
    transform: scale(1.05);
  }
</style>
